import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InsuranceService } from 'src/app/Services/AdminConfigurations/insurance.service';
import { InsuranceCarriers } from 'src/app/models/InsuranceCarriers';
import { MatTableDataSource, MatPaginator } from '@angular/material';

@Component({
  selector: 'app-professional-payer',
  templateUrl: './professional-payer.component.html',
  styleUrls: ['./professional-payer.component.css']

})
export class ProfessionalPayerComponent implements OnInit {

  displayedColumns: string[] = ['InsuranceCarrierId', 'InsuranceFullName'];
  public payer: string;
  ccPayers: InsuranceCarriers[];
  payersDataSource: any;
  selectedRow: any = '';
  public payerType: string;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  profesionalform: FormGroup;
  submitted = false;
  message: string = '';

  constructor(private formBuilder: FormBuilder, public dialogRef: MatDialogRef<ProfessionalPayerComponent>,
    @Inject(MAT_DIALOG_DATA) public passedData: string, private insurance: InsuranceService) {
    this.payerType = passedData;
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.profesionalform = this.formBuilder.group({
      payerName: ['',]
    });
  }

  get f() { return this.profesionalform.controls; }

  onSubmit() {
    this.submitted = true;
  }
  close(): void {
    this.dialogRef.close();
  }

  oncellclick(row: any) {
    this.message=''
    this.selectedRow = row;
  }

  getPayerDetails() {
    this.message='';
    this.payer = this.profesionalform.value.payerName;
    if (this.payer != "" && this.payer.length !=0) {
      this.insurance.getCCPayers(this.payerType, this.payer).subscribe(data => {
        this.ccPayers = data;
        this.payersDataSource = new MatTableDataSource<InsuranceCarriers>(this.ccPayers);
        this.payersDataSource.paginator = this.paginator;
      })
    }
    else
    {
      this.message = 'Please enter insurance name';
    }
  }

  addPayer() {
    if (this.selectedRow.insuranceCarrierId === undefined) {
      this.message = 'Please select any payer'
    }
    else {
      this.dialogRef.close({
        insId: this.selectedRow.insuranceCarrierId,
        insName: this.selectedRow.insFullName
      });
    }
  }

  clearPayer()
  {
    this.profesionalform.patchValue({
      payerName:''
    })
  }
}




